/**
 * Punto de entrada legacy para el cliente HTTP compartido.
 * Preferir `import apiClient from '@shared/services/http'` en código nuevo.
 */
import apiClient, { TIMEOUTS as coreTimeouts } from '@shared/services/http/apiClient';

export default apiClient;

/** Compatibilidad: el nombre antiguo era RENEW; en apiClient es RENEW_SESSION */
export const TIMEOUTS = {
  ...coreTimeouts,
  RENEW: coreTimeouts.RENEW_SESSION,
};
